
import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
} from 'react';
import { Link, useHistory } from "react-router-dom";
// import SearchBar from "material-ui-search-bar";
import { Badge, Checkbox, Modal, Spin } from "antd";


import {
  Grid,
  TextField,
  Button,
  Avatar,
  IconButton,
  List,
  ListItem,
  Typography,
  FormLabel,
  Dialog,
  DialogContent,
  useMediaQuery,
  useTheme,
  makeStyles,
  CheckBox
} from '@material-ui/core';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


/** Third party packages & Dependencies */
import Webcam from "react-webcam";

import { useIdleTimer } from 'react-idle-timer';


/** Local Libraries, functions & dependencies */
import { errorMessage, helpers } from '../helpers';

import Services from '../Services';


/** Local Statics & Imports */
import { environment } from '../environments/environment';
import SearchBar from 'material-ui-search-bar';
import NewHireQueue from '../Pages/HR/NewHireQueue/NewHireQueue';
import { employeeStatuses } from '../Imports/employeeStatuses';
import EditEmergencyContact from './Modals/EditEmergencyContact';
import { States } from '../helpers/state';
import EmployeeIdModal from './Modals/EmployeeIdModal';
import EmployeeEmergencyContact from './Modals/EmployeeEMergencyContact';
import { useDispatch, useSelector } from 'react-redux';
import { setAccessTokens, setIsValueSet, setPageLoader, setSidebarCollapse } from '../redux/features/utils.slice';
import { utility } from '../helpers/loader';
import { LoadingOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { CloseRounded, MenuOpenOutlined, MenuOpenRounded, MenuRounded } from '@material-ui/icons';
import { sessionUpdate } from '../Services/users';
var moment = require('moment-timezone');


const {
  capitalize
} = helpers;

const {
  users,
  api: {
    routes
  },
  Storage,
  BroadcastClient,
  EventsClient,
  broadcast,
} = Services;

const {
  apiPath,
  autologoutPeriod,
} = environment;

const {
  hr,
  employee
} = Services;




const useStyles = makeStyles((theme) => ({
  Avatarlarge: {
    width: theme.spacing(17),
    height: theme.spacing(17),
  },
  DisplayNone: {
    display: 'none'
  }
}));

/** Pre-req Configuration */
const status = JSON.parse(localStorage.user_profile || '{}');
const isEmployee = status?.EmployeeStatusId > 8;


if (isEmployee)
  var broadcastListener;

let eventsListener;

if (isEmployee)
  var broadcastClient = new BroadcastClient({
    namespace: 'broadcast'
  });

const eventsClient = new EventsClient({
  namespace: 'events'
});

if (isEmployee)
  broadcastClient.connect();

if (localStorage.getItem('access_jwt'))
  eventsClient.connect();

window.addEventListener('applicant-logged-in', eventsClient.connect);

if (!localStorage.getItem('broadcasts'))
  localStorage.broadcasts = '[]';


const PageHeader = ({ search = false, rerender }) => {


  const [isRead, setIsRead] = useState(false)
  const videoConstraints = {
    width: 300,
    height: 300,
    facingMode: "user"
  };

  const webCamRef = useRef(null);

  const uploadAndHandleUX = async (image) => {
    const updatedPic = await users.setDisplayPicture({
      image
    });

    setSavingImage(false);

    triggerCamera(false);

    setDisplayPicture(image);
  }

  const captureImage = useCallback(
    async () => {
      try {

        setSavingImage(true);

        const image = webCamRef.current.getScreenshot();

        await uploadAndHandleUX(image);
      } catch (exc) {

      }

    },
    [webCamRef]
  );

  const uploadPhoto = () => {
    const el = document.getElementById('imageToUploadInput');

    el.click();
  }

  const handlePhoto = async ($e) => {
    const { files } = $e.target;

    const reader = new FileReader();

    const uri = await new Promise((resolve, reject) => {
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(files[0]);
    })

    await uploadAndHandleUX(uri);
  }

  const storage = new Storage();

  const history = useHistory();

  const classes = useStyles();

  const [cameraTriggered, triggerCamera] = useState(false);
  let { notifications: notifications_loader } = useSelector(state => state?.utils?.pageLoader)

  const [savingImage, setSavingImage] = useState(false);

  const [unReadNotificationsCount, setUnReadNotificationsCount] = useState(0)

  // const [openContact, setOpenContact] = useState(false);
  // const [employeeDetails, setEmployeeDetails] = useState({});
  // const [emergencyContact, setEmergencyContact] = useState();
  // const [flag, setFlag] = useState(false);

  // const onClickEditEmergencyContact = () => {
  //   // <EditEmergencyContact EmergencyEditModal={emergencyModalData} />
  //   setOpenContact(true);
  // };

  // let emergencyModalData = {
  //   employeeDetails: { ...JSON.parse(localStorage.getItem('user_profile')) },
  //   emergencyContact: emergencyContact,
  //   open: openContact,
  //   close: setOpenContact,
  //   statesList: States,
  //   mainFlag: flag,
  //   setMainFlag: setFlag,
  // };

  const [displayPicture, setDisplayPicture] = useState(
    storage.get('displayPicture')
  );

  let { collapse } = useSelector(state => state.utils)

  const [authenticatedHeader, setAuthHeader] = useState(
    localStorage.getItem('access_jwt') || ''
  )

  const dispatch = useDispatch()

  useEffect(() => {
    if (document) {
      let clone = document?.querySelector('#PageTitle')?.cloneNode(true);
      document?.querySelector('h1')?.appendChild(clone);
    }



  }, []);



  function logout(e, value) {

    let data = {
      id: 1,

    }
    if (value == 1) {
      data.id = 1
    }
    else {
      data.id = 2
    }

    try {
      let isEmployee = JSON.parse(localStorage.getItem('isEmployee'));
      // let login_source = JSON.parse(localStorage.getItem('Source'))
      if (isEmployee) {

        employee.logout(data).then(() => {
          dispatch(setAccessTokens({ token: null }))
          storage.clear();
          dispatch(setPageLoader({ pageName: "main", flag: false }))
          // if (login_source && login_source == 'Entra-ID')
          //   return window.location.href = `https://login.microsoftonline.com/${process?.env?.REACT_APP_ENTRA_TENANT_ID}/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURIComponent(`${process?.env?.REACT_APP_ENTRA_LOGOUT_REDIRECT_URL}/login/140040`)}`;
          return history.push('/login/140040');
        }
        ).catch((err) => { });
      }
      else {
        employee.Applicantlogout(data).then(() => {
          dispatch(setAccessTokens({ token: null }))
          storage.clear();
          dispatch(setPageLoader({ pageName: "main", flag: false }))
          return history.push('/');
        }).catch((err) => { });
      }



    }
    catch (exc) {


    }

  }



  const MenuOpen = (event) => {
    var element = document.getElementById("LeftContol");
    element.classList.remove("CloseMenu");

    var element = document.getElementById("LeftContol");
    element.classList.add("OpenMenu");
  };

  // Modal Profile Picture Changer
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const PicturehandleClickOpen = () => {
    let pastScreen = localStorage.getItem('pastScreen')
    let isEmployee = JSON.parse(localStorage.getItem('isEmployee'))
    let accessToken = localStorage.getItem('access_jwt')


    if (!accessToken) {


      if (isEmployee === false && pastScreen === 'Applicant') {
        localStorage.clear()
        history.push('/')
        errorMessage()
        return <></>
      }


      if (isEmployee === false && pastScreen === 'Employee') {
        localStorage.clear()
        history.push('/login/140040')
        errorMessage()
        return <></>
      }

      if (isEmployee === true && pastScreen === 'Employee') {
        localStorage.clear()
        history.push('/login/140040')
        errorMessage()
        return <></>
      }

      localStorage.clear()
      history.push('/')
      errorMessage()
      return <></>

    }

    setOpen(true);
  };

  const PicturehandleClose = () => {
    setOpen(false);
  };

  const retreiveDP = async () => {
    try {
      if (displayPicture)
        return false;


      if (storage.get('retreivingDp'))
        return false;

      storage.set('retreivingDp', true);

      var reader = new FileReader();


      const img = await fetch(
        apiPath
          .concat(routes.employee.getProfilePic),
        {
          headers: {
            Authorization: storage.get('access_jwt')
          }
        }
      );

      const dataBlob = await img.blob();

      const uri = await new Promise((resolve, reject) => {
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(dataBlob);
      })

      setDisplayPicture(uri);

      storage.set('displayPicture', uri);

      storage.remove('retreivingDp');

    } catch (exc) {
      //  

      storage.remove('retreivingDp');
    }
  };

  const getBroadcasts = () => {
    return JSON.parse(
      storage.get('broadcasts')
    ) || [];
  }

  const [broadcasts, insertBroadcasts] = useState(
    getBroadcasts()
  );

  const [notifications, setNotifications] = useState([]);

  // For Modal
  const [aletopen, setAlertOpen] = React.useState(false);
  const [custom, setCustom] = useState(false);
  const [customMessage, setCustomMessage] = useState({
    subject: '',
    message: '',
    id: null
  })
  //  const //theme = useTheme();
  //const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const acknowledgeAndClose = async (id) => {

    if (custom && id) await broadcast.acknowledgeAndClose({ id, is_read: isRead || false })
    else {
      setTimeout(() => {
        const [first, ...rest] = broadcasts;
        storage.set('broadcasts', JSON.stringify(rest));
        insertBroadcasts(rest);
      }, 0);
    }
    await retreiveBroadcasts();
    setIsRead(false)
    AlertPopOff();
  }

  //  isBroadCast true: broadcast socket
  //  isBroadCast false: notification onClick
  const AlertPop = (isBroadCast = true, val = {}) => {

    let typeMap = {
      1: () => {
        let { id, is_read, BroadcastMessage: { subject, message } } = val;
        if (!isBroadCast) {
          setCustom(true)
          setCustomMessage({ subject, message, id, is_read })
        }
        setAlertOpen(true);
      },
      3: async () => {
        const res = await broadcast.messageRead({ id: val?.id })
        if (res?.httpStatus === 200) {
          history?.push("/Locomotive-work-order-edit", { id: val?.WO_ID })
          localStorage.setItem("loco-wo-id", val?.WO_ID)
          utility?.dispatch(setIsValueSet(true))
        }
      }
    }

    return typeMap[val?.type]()

  };

  const AlertPopOff = () => {
    setAlertOpen(false);
  };

  const [isEmployeeLoggedIn, setIsEmployeeLoggedIn] = useState(false)


  useEffect(() => {
    const validateEmployee = JSON.parse(localStorage.getItem("isEmployee"))

    if (!validateEmployee) return

    if (isEmployee && !broadcastListener) {
      broadcastListener = BroadcastClient.broadcastListener((broadcastEvent) => {
        const {
          detail: broadcastObject
        } = broadcastEvent;

        const useBroadcasts = [...broadcasts, broadcastObject];

        insertBroadcasts(useBroadcasts);
      });
    }

    if (!eventsListener) {
      eventsListener = EventsClient.eventstListener((event) => {
        const {
          detail: eventObject
        } = event;
      });
    }

  }, []);

  const retreiveBroadcasts = async () => {
    try {
      if (!storage.get('access_jwt')) return
      utility?.dispatch(setPageLoader({ pageName: "notifications", flag: true }))
      const response = await broadcast.getAll();
      if (response?.httpStatus === 200) {
        utility?.dispatch(setPageLoader({ pageName: "notifications", flag: false }))
        const { data, unreadCount } = response;
        setNotifications(data)
        setUnReadNotificationsCount(unreadCount)
      }
    } catch (exc) {
      utility?.dispatch(setPageLoader({ pageName: "notifications", flag: false }))
    }
  }



  const retreiveBroadcasts2 = async () => {
    try {
      if (!storage.get('access_jwt'))
        return;
      const response = await broadcast.getAll();
      const { data } = response;

      const notificationsBuffer = data
        .reverse()
        .map(broadcast => {
          let {
            Employee: { dnUsername: from },
            BroadcastMessage: {
              SubDepartment: { name: to },
              createdAt: date,
              subject,
              message
            },
            is_read,
            id
          } = broadcast;

          date = new Date(date).toLocaleDateString()

          return {
            heading: to,
            body: message,
            subject,
            date,
            from,
            to,
            is_read,
            id
          }
        });
      const flter = notificationsBuffer.filter((data) => data.is_read == false)
      if (flter.length > 0)
        AlertPop(false, flter[0])

    } catch (exc) {

    }
  }
  useEffect(() => {
    if (!isEmployee)
      return;

    storage.set('broadcasts', JSON.stringify(broadcasts));
    if (getBroadcasts().length) {
      AlertPop(true);
    }

  }, [broadcasts])

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("isEmployee"))) retreiveBroadcasts();
  }, [rerender])

  useEffect(() => {
    if (history?.location?.state?.broaCast == true) retreiveBroadcasts2()
  }, [])


  useEffect(() => {
    setIsEmployeeLoggedIn(JSON.parse(localStorage?.getItem("isEmployee")))
    if (JSON.parse(localStorage?.getItem("isEmployee"))) {
      retreiveBroadcasts()
      retreiveDP()
    }

  }, [JSON.parse(localStorage?.getItem("isEmployee"))])

  /** Retreiving user profile information, cached in localstorage.
   * TO APPLY - state service later
   */
  const userProfile = JSON.parse(
    localStorage.getItem('user_profile')
  ) || { userName: 'Not Found' };

  if (userProfile) {

    var {
      dnUsername,
      firstName,
      lastName,
    } = userProfile;

    dnUsername = capitalize(dnUsername || '');
    firstName = capitalize(firstName || '');
    lastName = capitalize(lastName || '');

    /** dnUserName is for employees, firstName & lastName is for applicants */
    dnUsername = dnUsername || `${firstName} ${lastName}` || 'Not Found';
  }


  /********************************************************** */

  /** Setting Header styles if the user is authenticated */

  const headerClassName = authenticatedHeader ? '' : classes.DisplayNone;


  /********************************************************** */

  /****** IDLE / INACTIVITY AUTOLOGOUT *************************************** */

  const lastAPICallTime = useRef(Date.now());
  const ONE_MINUTE = 1000 * 60; // 5 minutes in milliseconds
  const yourApiFunction = async () => {
    await sessionUpdate()

  };

  const handleUserAction = () => {
    const now = Date.now();
    if (now - lastAPICallTime.current >= ONE_MINUTE) {
      lastAPICallTime.current = now;
      const is_employee = JSON.parse(localStorage.getItem('isEmployee'))
      if (is_employee && is_employee == false)
        yourApiFunction();
    }
  };

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * 15, // 15 minutes idle timeout
    onIdle: (e) => {
      logout(e, 2); // Your logout function
    },
    onActive: () => {
      console.log('User is active again');
    },
    onAction: handleUserAction,
    debounce: 500
  });

  /********************************************************** */


  let notificationContent = (notification, type) => {
    let heading = {
      2: "Ticket Closed",
      3: "Work Order Notes" + `- ${notification?.WO_ID}`
    }
    let subHeading = {
      2: notification?.Ticket?.close_comment,
      3: notification?.message,
      "default": notification?.BroadcastMessage?.subject || null
    }
    let date = {
      3: notification?.createdAt,
      default: notification?.Ticket?.createdAt
    }

    let typeMap = {
      heading: heading[notification?.type],
      subHeading: subHeading[notification?.type || "default"],
      date: moment(new Date(date[notification?.type === 3 ? 3 : "default"]))?.utc()?.format('MM-DD-YYYY hh:mm:ss').toString()
    }

    return typeMap[type]

  }


  return (
    <Grid style={{ position: "relative" }}>
      <Grid xs={12}>
        {collapse && <MenuUnfoldOutlined onClick={() => utility?.dispatch(setSidebarCollapse(false))} style={{ cursor: "pointer", fontSize: "20px", position: "absolute", top: "-20px", left: "0px" }} />}
        <Grid xs={12} className="PageHeader">
          <Grid xs={5} className="PageTitle">
            {/* <Button onClick={MenuOpen} /> */}
            <h1></h1>
          </Grid>

          <Grid xs={3} className='searchbar'>
            {search && <SearchBar
              value={''}
              style={{ width: '100%', boxShadow: 'none' }}
            />}
          </Grid>


          <Grid xs={4}
            container
            justify="flex-end"
            alignItems="center"
            className={headerClassName}>
            <Grid lg={12} container justify="flex-end">
              <Grid xs className="HeaderSearchBox d-none">
                <Button></Button>
                <TextField id="Header-Search" label="Search" />
              </Grid>

              {isEmployeeLoggedIn &&
                <Spin
                  spinning={notifications_loader || false}
                  indicator={<LoadingOutlined
                    style={{
                      fontSize: 24,
                    }}
                    spin
                  />}>
                  <Badge count={unReadNotificationsCount}>
                    <Button className="HeadAlert" style={{ height: "50px", marginTop: "6px" }}>
                      <Grid className="HeaderNotificationn-Notification">
                        <List component="nav" aria-label="main mailbox folders" className="HeaderNoti Scrolling AlertNoti" style={{ background: 'white' }}>
                          {
                            notifications.length
                              ? notifications
                                .map((notification) => {
                                  return <ListItem onClick={() => {
                                    setIsRead(false)
                                    AlertPop(false, notification)
                                  }}
                                    className={
                                      notification.is_read
                                        ? ''
                                        : 'UnreadAlert'
                                    }>

                                    <Grid xs={12}>
                                      <FormLabel>{notification.data}</FormLabel>
                                      <div style={{ display: "flex", flexDirection: "column", gap: "1px", marginBottom: "10px" }}>
                                        <Typography variant="h6" component="h6">
                                          {notificationContent(notification, "heading")}
                                        </Typography>
                                        <span style={{ fontSize: "12px", fontWeight: 500 }}>{notificationContent(notification, "subHeading")}</span>
                                      </div>
                                      {notification?.BroadcastMessage?.message || notificationContent(notification, "date")}
                                    </Grid>
                                  </ListItem>
                                })
                              : (
                                <Grid
                                  style={{
                                    margin: '1rem 0px'
                                  }}>
                                  No broadcasts available
                                </Grid>
                              )
                          }
                        </List>
                      </Grid>
                    </Button>
                  </Badge>
                </Spin>
              }

              <Button className="HeadAlertt">
                <Avatar alt={dnUsername} src={displayPicture} className="mx-1" />
                {dnUsername}
                <IconButton edge="end" aria-label="comments">
                  <ExpandMoreIcon />
                </IconButton>

                <Grid className="HeaderNotificationn">
                  <List
                    component="nav"
                    aria-label="main mailbox folders"
                    className="HeaderNoti Scrolling AlertNoti"
                    style={{ border: '1px solid', background: 'white', height: '20px' }}
                  >
                    {JSON.parse(localStorage.getItem("isEmployee")) ? (
                      <ListItem className="ChangePictureIcon" style={{ paddingLeft: '12px' }}>
                        <Grid onClick={PicturehandleClickOpen} className="ProfilePicChangeBtn" style={{ paddingLeft: '12px' }}>
                          Change Picture
                        </Grid>
                      </ListItem>
                    ) : null}

                    <ListItem className="LogOutIcon LogoutButton" onClick={(e) => logout(e, 1)}>
                      <Button>
                        Logout
                      </Button>
                    </ListItem>
                  </List>
                </Grid>

              </Button>
              {/* {isEmployee ? (<Button className='mt20' style={{background:'#2963AD',color:'white',padding:'10px'}} >

                <Grid onClick={onClickEditEmergencyContact} className="">
                  <Typography> Update Emergency Contact</Typography>
                </Grid>
                <EmployeeEmergencyContact EmergencyEditModal={emergencyModalData} />

              </Button>) : ''} */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Picture Change Modal */}
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={PicturehandleClose}
        className="ProfilePicChange"
        aria-labelledby="responsive-dialog-title"
      >
        <Button autoFocus onClick={PicturehandleClose} className="ModalClose">
        </Button>
        <DialogContent>
          <Grid xs={12} className="mbold f20">
            Change Picture
          </Grid>
          <Grid xs={12} className="tcenter mt30">
            {dnUsername}, Keep your profile fresh!
          </Grid>
          <Grid xs={12} container justify="center" className="mt40 position-relative">
            <div
              className={
                savingImage
                  ? 'backdrop'
                  : 'd-none'
              }
            >
              <span>Saving...</span>
            </div>
            <Webcam
              videoConstraints={videoConstraints}
              ref={webCamRef}
              className={
                'rounded scale-x-_1 ' + (
                  cameraTriggered
                    ? ''
                    : 'd-none'
                )
              } />
            <Button className={
              cameraTriggered
                ? 'ApplicantBtn my-2'
                : 'd-none'
            }
              onClick={captureImage}>
              Capture
            </Button>
            <Avatar alt={dnUsername} src={displayPicture} className={
              cameraTriggered
                ? 'd-none'
                : classes.Avatarlarge
            } />
          </Grid>
          <Grid xs={12} className="tcenter mt20">
            Take or upload a photo
          </Grid>
          <Grid xs={12} className="ProfileUpdateBtn mt30">
            <Button
              className={
                cameraTriggered
                  ? 'd-none'
                  : ''
              }
              onClick={
                triggerCamera.bind(null, true)
              }>Use Camera</Button>
            <Button onClick={uploadPhoto}>Upload Photo</Button>
            <input
              id="imageToUploadInput"
              type="file"
              accept="img/*"
              onChange={handlePhoto}
              hidden />
          </Grid>
        </DialogContent>
      </Dialog>
      {/* Picture Change Modal Close */}


      <Modal
        open={aletopen}
        onCancel={AlertPopOff}
        footer={false}
        header={false}
        centered
        mask={false}
      >

        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ fontSize: "12px", fontWeight: "600" }}>Subject</span>
            <span className="AlertPopTextBox AlertPopTextarea" style={{ margin: "0px" }}>
              {custom ? customMessage.subject : broadcasts?.[0]?.subject}
            </span>
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ fontSize: "12px", fontWeight: "600" }}>Message</span>
            <span className="AlertPopTextBox AlertPopTextarea" style={{ margin: "0px" }}>
              {custom ? customMessage.message : broadcasts?.[0]?.message}
            </span>
          </div>

          {
            custom & !customMessage?.is_read ? <>
              <Checkbox checked={isRead} onChange={(e) => setIsRead(e.target.checked)} >Check here to confirm you have read this message</Checkbox>

              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <button onClick={() => acknowledgeAndClose(customMessage.id)} style={{ width: "50%" }} className="LinkButton" disabled={!isRead ? true : false}>
                  Acknowledge & Close
                </button>
              </div>
            </>
              : null}

        </div>

      </Modal>

    </Grid >
  );
}
export default PageHeader;
